import './styles.scss';

import { each } from 'lodash';

const CheckboxGroup = () => import('../../components/checkbox-group/index.vue');

export default {
    name: 'EmergencyMessagesPage',

    components: {
        'checkbox-group': CheckboxGroup
    },

    data() {
        return {
            list: []
        }
    },

    computed: {
        subscription() {
            return this.$store.state.subscriptions.active_subscription;
        },
        stored_roles() {
            return this.$store.state.messaging.roles;
        },
        building() {
            return this.$store.getters.getActiveBuilding;
        },
        roles() {
            const roles = this.$store.getters.getActiveBuilding.roles;
            const all_roles = [];
            each(roles, (role) => {
                const obj = {
                    title: role.name,
                    id: role.id,
                    isChecked: false
                }
                all_roles.push(obj);
            });
            return all_roles;
        }
    },

    watch: {
        roles() {
            if (!this.stored_roles.length) {
                this.list = this.roles;
                this.updateValues(this.roles);
            }
        }
    },

    created() {
        this.$store.commit('setMenuDetails', {  
            title: 'Emergency Messages', 
            slug: 'messaging',
            back_url: '/action'
        });

        if (this.stored_roles.length) {
            this.list = this.stored_roles;
        }
        
        this.$store.dispatch('fetchBuildingProfile');
    },

    methods: {
        updateValues(list) {
            this.list = list;
            this.$store.commit('setMessageRoles', list);
        },

        next() {
            this.$store.commit('setMessageRoles', this.list);
            this.$router.push('/action/emergency-messages/group-types');
        },

        cancel() {
            this.$ionic.alertController.create({
                header: 'Are you sure you want to cancel?',
                message: 'This action cannot be undone.',
                buttons: [
                    {
                        text: 'Yes',
                        handler: () => {
                            this.$store.commit('resetMessage');
                            if (this.$store.state.messaging.group_types.length) {
                                this.$router.push('/action#back');
                            } else {
                                this.$router.go(-1);
                            }
                        },
                    },
                    {
                        text: 'No',
                        role: 'cancel'
                    }
                ],
            }).then(a => a.present());
        }
    }
};